import {
  actionTypes as asyncTypes, 
} from "async-ops";

export const TOGGLE_VIEW_AI_SUMMARY_POP_UP = "TOGGLE_VIEW_AI_SUMMARY_POP_UP";
export const CURRENT_LIVEBOARD = "CURRENT_LIVEBOARD";
export const SET_AI_SUMMARY = "SET_AI_SUMMARY";

const initialState = {
  isLoading: false,
  aiSummary: {
    summaryText: null,
    createdDate: null,
  },
};
export default function(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_VIEW_AI_SUMMARY_POP_UP:
      return {
        ...state,
        isAiSummaryPanelOpen: action.data.isAiSummaryPanelOpen,
      };
    case SET_AI_SUMMARY:      
      return {
        ...state,
        aiSummary: {
          summaryText: action.data.summaryText ||null,
          createdDate: action.data.createdDate,
        },
        liveBoardId: action.data.liveBoardId
      }
    case CURRENT_LIVEBOARD:
      return {
        ...state,
        liveBoardId: action.data.liveBoardId,
        liveBoardName: action.data.liveBoardName,
      };    
    case asyncTypes.OPERATION:      
    case asyncTypes.COMPLETE:      
    case asyncTypes.FAILURE:      
      return state;
    default:
      return state;
  }
}
